module.exports = __webpack_public_path__ + "static/img/3.2c472e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/3.png
// module id = hCEy
// module chunks = 0